import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import { Button } from "react-bootstrap";
import "./ItemClimateComponent.css";

export default function ItemClimateComponent(props) {
  const langData = require("../../../Data/language.json");
  const [carbonExists, setCarbonExists] = useState(false);
  const [waterExists, setWaterExists] = useState(false);
  const [climateScore, setClimateScore] = useState("");
  const [totalWater, setTotalwater] = useState("");
  const [grayPercent, setGrayPercent] = useState("");
  const [greenPercent, setGreenPercent] = useState("");
  const [bluePercent, setBluePercent] = useState("");
  const [carbonDialog, setCarbonDialog] = useState(false);
  const [waterDialog, setWaterDialog] = useState(false);

  /*NOT USED
    const [waterSourceId, setWaterSourceId] = useState("")
    const [waterMotivations, setWaterMotivations] = useState([])

    const [carbonSourceId, setCarbonSourceId] = useState("")
    const [carbonMotivations, setCarbonMotivations] = useState([])

     */

  useEffect(() => {
    if (props.carbon_fp !== undefined && props.carbon_fp !== "") {
      setCarbonExists(true);
      setClimateScore(props.carbon_fp.climateScore);
      /* NOT USED 
            setCarbonSourceId(props.carbon_fp.source_id)
            let splittedList = props.carbon_fp.description.split("Baserat på att")
            splittedList.shift()
            setCarbonMotivations(splittedList) */
    }

    if (props.water_fp !== undefined && props.water_fp !== "") {
      setWaterExists(true);
      setTotalwater(props.water_fp.totalwater);
      setGrayPercent(Math.floor(props.water_fp.grayPercent));
      setGreenPercent(Math.floor(props.water_fp.greenPercent));
      setBluePercent(Math.floor(props.water_fp.bluePercent));
      /* NOT USED 
            setWaterSourceId(props.water_fp.source_id)
            let splittedList = props.water_fp.description.split("Baserat på att")
            splittedList.shift()
            setWaterMotivations(splittedList)
            */
    }
  }, []);

  var climateScoreStyle = { width: "60px" };
  var motivation = langData[props.language].climate.item.verySmallImpact;

  if (climateScore === 2) {
    motivation = langData[props.language].climate.item.smallImpact;
  } else if (climateScore === 3) {
    motivation = langData[props.language].climate.item.impact;
  } else if (climateScore === 4) {
    motivation = langData[props.language].climate.item.largeImpact;
  } else if (climateScore === 5) {
    motivation = langData[props.language].climate.item.veryLargeImpact;
  }

  const handleCarbonDialogClose = () => {
    setCarbonDialog(false);
  };

  const handleWaterDialogClose = () => {
    setWaterDialog(false);
  };

  /* NOT USED
    carbonMotivations.map((elem, index) => {
                        return (<p className="motivationText" key={index}>{elem}</p>)
                    })
    
    waterMotivations.map((elem, index) => {
        return (<p className="motivationText" key={index}>{elem}</p>)
    }) */
  return (
    <div id="itemClimateInfoWrapper">
      {carbonExists ? (
        <div className="container-fluid climateScoreContainer">
          <p className="motivationText">{motivation}</p>

          <div className="leafContainer">
            <img
              className="itemClimateScore"
              style={climateScore === 1 ? climateScoreStyle : {}}
              src={require(`../../../Images/Icons/score1.svg`)}
              alt="climateScore"
            />
            <img
              className="itemClimateScore"
              style={climateScore === 2 ? climateScoreStyle : {}}
              src={require(`../../../Images/Icons/score2.svg`)}
              alt="climateScore"
            />
            <img
              className="itemClimateScore"
              style={climateScore === 3 ? climateScoreStyle : {}}
              src={require(`../../../Images/Icons/score3.svg`)}
              alt="climateScore"
            />
            <img
              className="itemClimateScore"
              style={climateScore === 4 ? climateScoreStyle : {}}
              src={require(`../../../Images/Icons/score4.svg`)}
              alt="climateScore"
            />
            <img
              className="itemClimateScore"
              style={climateScore === 5 ? climateScoreStyle : {}}
              src={require(`../../../Images/Icons/score5.svg`)}
              alt="climateScore"
            />
          </div>
          <p className="climateHelperText">
            {langData[props.language].climate.item.climateHelperText}
          </p>

          <img
            className="helpIcon"
            onClick={() => setCarbonDialog(true)}
            src={require(`../../../Images/Icons/helpIcon.svg`)}
            alt="climateScore"
          />
        </div>
      ) : (
        <div className="missingClimateInfoContainer">
          <img
            src={require("../../../Images/Icons/scoreNan.svg")}
            alt="missingClimateScore"
            className="missingDataIcon"
          />
          <p className="climateText">
            {" "}
            {langData[props.language].climate.item.carbonDataMissing}
          </p>
        </div>
      )}

      {waterExists ? (
        <div className="container-fluid waterContainer">
          <p className="motivationText">
            {langData[props.language].climate.item.consumedWater}
          </p>
          <p className="waterLiters">
            {totalWater} {langData[props.language].climate.item.liter}
          </p>
          <div className="container-fluid waterPercentageDiv col-10">
            <span className="row waterVisual">
              <div
                className="greenWater"
                style={{ width: `${greenPercent}%` }}
              />
              <div className="blueWater" style={{ width: `${bluePercent}%` }} />
              <div className="greyWater" style={{ width: `${grayPercent}%` }} />
            </span>
            <div
              className="row"
              style={{ textAlign: "center", marginTop: "5px" }}
            >
              <div className="container-fluid col-2 percentageTextCont">
                <img
                  className="dropImg"
                  src={require(`../../../Images/Icons/greenDrop.svg`)}
                  alt="greenDrop"
                />
                <p className="percentageText">{greenPercent}%</p>
              </div>
              <div className="container-fluid col-2 percentageTextCont">
                <img
                  className="dropImg"
                  src={require(`../../../Images/Icons/blueDrop.svg`)}
                  alt="blueDrop"
                />
                <p className="percentageText">{bluePercent}%</p>
              </div>
              <div className="container-fluid col-2 percentageTextCont">
                <img
                  className="dropImg"
                  src={require(`../../../Images/Icons/greyDrop.svg`)}
                  alt="greyDrop"
                />
                <p className="percentageText">{grayPercent}%</p>
              </div>
            </div>
          </div>

          <img
            className="helpIcon"
            onClick={() => setWaterDialog(true)}
            src={require(`../../../Images/Icons/helpIcon.svg`)}
            alt="climateScore"
          />
        </div>
      ) : (
        <React.Fragment>
          <hr />
          <div className="missingClimateInfoContainer">
            <img
              src={require("../../../Images/Icons/greyDrop.svg")}
              alt="missingClimateScore"
              className="missingDataIcon"
            />
            <p className="climateText">
              {" "}
              {langData[props.language].climate.item.waterDataMissing}
            </p>
          </div>
        </React.Fragment>
      )}
      <Dialog
        onClose={() => handleCarbonDialogClose()}
        aria-labelledby="invDialogTitle"
        open={carbonDialog}
        fullwidth={"true"}
      >
        <div className="container-fluid col-12 closeBtnContainer">
          <Button
            className="closeClimateDialogBtn"
            onClick={() => setCarbonDialog(false)}
          >
            <img
              src={require("../../../Images/Icons/No.svg")}
              alt="backIcon"
            ></img>
          </Button>
        </div>
        <div className="container-fluid col-12 dialogTitleContainer">
          <h5 className="dialogTitle">
            {langData[props.language].climate.item.carbonFootprint}
          </h5>
        </div>
        <div className="container-fluid col-12 carbonDialogContainer">
          <p className="consupediaHelperText">
            {langData[props.language].climate.item.consupediaText}
          </p>
          <p className="longText">
            {langData[props.language].climate.item.longCarbonText}
          </p>
          <p className="longText">
            {langData[props.language].climate.item.scaleExplanation}
          </p>
          <hr />
          <div className="container-fluid companyIconContainer">
            <p className="dataFromText">
              {" "}
              {langData[props.language].climate.item.dataFrom}:{" "}
            </p>
            <a href={"https://www.ri.se/sv/media/906/download"}>
              <img
                className="riseLogo"
                src={require("../../../Images/riseLogo.png")}
                alt="riseLogo"
              ></img>
            </a>
          </div>
        </div>
      </Dialog>
      <Dialog
        onClose={() => handleWaterDialogClose()}
        aria-labelledby="waterFootPrintTitle"
        open={waterDialog}
      >
        <div className="container-fluid col-12 closeBtnContainer">
          <Button
            className="closeClimateDialogBtn"
            onClick={() => setWaterDialog(false)}
          >
            <img
              src={require("../../../Images/Icons/No.svg")}
              alt="backIcon"
            ></img>
          </Button>
        </div>
        <div className="container-fluid col-12 dialogTitleContainer">
          <h5 className="dialogTitle">
            {langData[props.language].climate.item.waterFootprint}
          </h5>
        </div>
        <div className="container-fluid col-12 carbonDialogContainer">
          <p className="consupediaHelperText">
            {langData[props.language].climate.item.consupediaText}
          </p>
          <p className="longText">
            {langData[props.language].climate.item.longTextWater}
          </p>
          <table className="waterTable">
            <tbody>
              <tr>
                <td className="dropletTd">
                  <img
                    className="dropImg"
                    src={require(`../../../Images/Icons/greenDrop.svg`)}
                    alt="greenDrop"
                  />
                </td>
                <td className="descriptionTd">
                  <p className="longText">
                    {langData[props.language].climate.item.greenWater}
                  </p>
                </td>
              </tr>
              <tr>
                <td className="dropletTd">
                  <img
                    className="dropImg"
                    src={require(`../../../Images/Icons/blueDrop.svg`)}
                    alt="blueDrop"
                  />
                </td>
                <td className="descriptionTd">
                  <p className="longText">
                    {langData[props.language].climate.item.blueWater}
                  </p>{" "}
                </td>
              </tr>
              <tr>
                <td className="dropletTd">
                  <img
                    className="dropImg"
                    src={require(`../../../Images/Icons/greyDrop.svg`)}
                    alt="greyDrop"
                  />
                </td>
                <td className="descriptionTd">
                  <p className="longText">
                    {langData[props.language].climate.item.greyWater}
                  </p>{" "}
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
          <div className="container-fluid companyIconContainer">
            <p className="dataFromText">
              {" "}
              {langData[props.language].climate.item.dataFrom}
            </p>
            <a
              href={
                "http://www.waterfootprint.org/Reports/Report50-NationalWaterFootprints-Vol1.pdf"
              }
            >
              <img
                className="waterFpLogo"
                src={require("../../../Images/waterFPlogo.png")}
                alt="waterFPLogo"
              ></img>
            </a>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
